export const SETSALESORDERLIST = "SETSALESORDERLIST";
export const SETSALESORDERINFO = "SETSALESORDERINFO";
export const SETSTATUSLIST = "SETSTATUSLIST";
export const SETATTACHMENTLIST = "SETATTACHMENTLIST";
export const SETEQUIPMENTLIST = "SETEQUIPMENTLIST";
export const SETITEMLIST = "SETITEMLIST";
export const SETADDRESSLIST = "SETADDRESSLIST";
export const SETEQUIPMENTPARTSLIST = "SETEQUIPMENTPARTSLIST";
export const SETSALESORDERITEMS = "SETSALESORDERITEMS";
export const SETSQSOCOMPARISON = "SETSQSOCOMPARISON";
export const SETEMAILCONTENTLIST = "SETEMAILCONTENTLIST";
export const SOCLEARDOC = "SOCLEARDOC";
export const SETPREVIEWREPORT = "SETPREVIEWREPORT";